<template>
  <div class="requestlistdetail">
    <div class="row m-0 h-100 justify-content-center align-items-center" v-if="isLoading">
      <b-spinner  variant="secondary"/>
    </div>
    <div v-else class="requestlistdetail__tab2">
      <div :class="getFreightMode(custDetail.service_head) === 'Air' ? 'purpleclass' : getFreightMode(custDetail.service_head) === 'Land' ? 'deepgreenclass' : 'blueclass'">
        <b-card no-body>
          <b-tabs pills card vertical>
            <b-tab v-model="tabIndex"  v-for="(item, idx) in tablist" :key="idx">
              <template #title>
                <img :src="item.icon" alt="">
              </template>
              <div class="requestlistdetail__content2">
                <h4>{{item.text}}</h4>
                <keep-alive>
                  <component
                    :is="item.component"
                    :typeRequest="typeRequest"
                    :custDetail="custDetail"
                    :isLoading="isLoading"
                  >
                  </component>
                </keep-alive>
              </div>
            </b-tab>
            <!-- <b-tab title="Tab 2"><b-card-text>Tab contents 2</b-card-text></b-tab>
            <b-tab title="Tab 3"><b-card-text>Tab contents 3</b-card-text></b-tab> -->
          </b-tabs>
        </b-card>
      </div>
      
    </div>

  </div>
</template>

<script>
import mixin from '@/mixin/getters/shipment-details'

import AddressDetails from './tabs-detail/AddressDetails.vue'
import ShipmentType from './tabs-detail/ShipmentType.vue'
import ProductDetails from './tabs-detail/ProductDetails.vue'
import Others from './tabs-detail/Others.vue'

export default {
  name: 'DetailsAirOcean',
  props: {
    typeRequest: String,
    custDetail: Object,
    isLoading: Boolean
  },
  components: {
    AddressDetails,
    ShipmentType,
    ProductDetails,
    Others
  },
  mixins: [mixin],
  data () {
    return {
      tabIndex: 0,
      tablist: [
        {
          text: 'Shipping Details Address',
          icon: require('@/assets/image/icon/details_address.svg'),
          component: AddressDetails
        },
        {
          text: 'Shipment Type',
          icon: require('@/assets/image/icon/shipment_type.svg'),
          component: ShipmentType
        },
        {
          text: 'Product Details',
          icon: require('@/assets/image/icon/product_details.svg'),
          component: ProductDetails
        },
        {
          text: 'Others',
          icon: require('@/assets/image/icon/others.svg'),
          component: Others
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/DetailsAirOcean.vue